import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { parseDateTime } from "@internationalized/date";
import dayjs from "dayjs";
import { DatePicker } from "../DatePicker";

/**
 * @callback childrenRender
 * @param {{disclosure: import("@chakra-ui/react").UseDisclosureReturn}} disclosure
 */
/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/RentalArea").RentalArea} rentalArea
 * @property {(event: any) => void} setDate
 * @property {()=>void} [onClick]
 * @property {childrenRender} children
 */
/**
 * @param {Props} props
 */
export function CalendarModal({ rentalArea, setDate, onClick, children }) {
  const disclosure = useDisclosure();

  const { isOpen, onClose } = disclosure;

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>
            <ModalCloseButton />
          </ModalHeader>

          <ModalBody>
            <Box>
              <DatePicker
                rentalArea={rentalArea}
                minValue={parseDateTime(dayjs().format("YYYY-MM-DD"))}
                onClick={onClick}
                onChange={(event) => {
                  setDate(event.target.value);
                }}
              />
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>

      {children({ disclosure })}
    </>
  );
}
